import React from "react";
import InvImage from "../InvImage";

class OCTGuiding extends React.Component {
  render() {
    return (
      <div>
        <InvImage src={this.props.imageSrc} />
      </div>
    );
  }
}

export default OCTGuiding;
